// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const hexToRGBA = (hex: string, alpha: number) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const styles = (theme: any) => ({
  pageWrapper: {
    width: 600,
    margin: '0 auto',
  },
  margin: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(8),
  },
  list: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridRowGap: theme.spacing(2),
    alignItems: 'center',
  },
  acreageList: {
    gridRowGap: 0,
    marginBottom: 0,
  },
  progressBar: {
    marginBottom: 0,
  },
  progressBarContainer: {
    marginBottom: theme.spacing(3),
  },
  bar2: {
    backgroundColor: theme.palette.secondary.main,
  },
  dashedBar: {
    animation: 'none',
    backgroundColor: theme.palette.lightGrey,
    backgroundImage: 'none',
  },
  alignRight: {
    justifySelf: 'right',
  },
  title: {
    marginBottom: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  divider: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    height: 2,
  },
  dayWidth: {
    flex: 1,
    maxWidth: '13.5%',
    minWidth: '13.5%',
    margin: '2px',
  },
  emptyDay: {
    flex: 1,
    maxWidth: '13.5%',
    minWidth: '13.5%',
    margin: '2px',
    backgroundColor: '#EFEFEF',
  },
  calendarHeaders: {
    flex: 1,
    maxWidth: '13.5%',
    minWidth: '13.5%',
    margin: '2px',
    padding: 0,
  },
  calendarDay: {
    flex: 1,
    maxWidth: '13.5%',
    minWidth: '13.5%',
    margin: '2px',
    height: '50px',
    backgroundColor: hexToRGBA(theme.palette.primary.main, 0.1),
  },
  calendarContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'stretch',
  },
  loginsCircle: {
    borderRadius: '50%',
    height: '37px',
    width: '37px',
    minHeight: '37px',
    minWidth: '37px',
    maxHeight: '37px',
    maxWidth: '37px',
    aspectRatio: '1 / 1',
    padding: 0,
    margin: '6.5px auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.15)',
    flexShrink: 0,
    backgroundColor: theme.palette.primary.main,
  },
  loginsCircleText: {
    color: 'white',
    lineHeight: '1',
    fontSize: '18px',
  },
  loginsZeroText: {
    color: 'black',
    lineHeight: '50px',
    fontSize: '18px',
  },
  topMargin: {
    marginTop: theme.spacing(2),
  },
  creditUsage: {
    gridColumn: 'span 2',
  },
  leftText: {
    fontWeight: 500,
    color: 'rgba(0, 0, 0, 0.7)',
  },
  planWithDate: {
    color: 'rgba(0, 0, 0, 0.7)',
  },
  exportButton: {
    backgroundColor: '#E5EAEE',
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(1),
    textDecoration: 'none',
    border: 'none',
    cursor: 'pointer',
    borderRadius: '4px',
    width: '100px',
  },
  exportButtonText: {
    color: '#021E40',
  },
  creditsPerMonthHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  creditsRemaining: {
    backgroundColor: `${theme.palette.primary.main}1A`,
    padding: theme.spacing(2),
    borderRadius: '4px',
    '& .MuiLinearProgress-root': {
      borderRadius: '4px',
      marginTop: theme.spacing(2),
    },
  },
});

export default styles;
